/* istanbul ignore file */
import React from 'react';
import { Box } from '@mui/material';
import type { BadgeProps } from 'framework/ui/mui-builder';

const EmployeeContractWillExpireSoonBadge: React.FC<BadgeProps> = () => {
  return (
    <Box
      component="i"
      data-testid="employee-contract-will-expire-soon-badge"
      className="fa fa-exclamation-circle"
      title="Contract will expire soon"
      sx={{ color: 'error.main', marginLeft: 1 }}
    />
  );
};

export default EmployeeContractWillExpireSoonBadge;
